import { createBasePlugin } from 'wix-rich-content-plugin-commons';
import { TEXT_COLOR_TYPE } from './types.js';
import { createTextColorToolbar } from './toolbar/createToolbar.js';
import { DEFAULTS } from './constants.js';
import './toolbar/getTextColorButtonProps.js';
import 'react';
import 'wix-rich-content-editor-common';
import './toolbar/TextColorPanel.js';
import 'prop-types';
import './text-decorations-utils.js';
import './color-scheme-utils.js';
import 'wix-rich-content-common';
import 'lodash';
import './toolbar/TextColorIcon.js';
import './toolbar/TextHighlightIcon.js';
import './toolbar/TextColorButton.js';
import './toolbar/BaseTextColor.js';
import 'classnames';
import 'react-modal';
import './toolbar/TextHighlightButton.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const createTextColorPlugin = (config) => {
  const type = TEXT_COLOR_TYPE;
  const _a = config, { theme, [type]: settings = {} } = _a, rest = __objRest(_a, ["theme", __restKey(type)]);
  const toolbar = createTextColorToolbar(config);
  return createBasePlugin(__spreadValues({
    theme,
    toolbar,
    type,
    settings,
    defaultPluginData: DEFAULTS.configTextColor.editor
  }, rest));
};
createTextColorPlugin.functionName = TEXT_COLOR_TYPE;

export { createTextColorPlugin };
//# sourceMappingURL=createTextColorPlugin.js.map
